// TODO move to cortex std

/**
 * Returns a new string which has had its first character turned into an
 * uppercase variant.
 */
export function capitalizeFirstLetter(string: string): string {
	if (typeof string !== 'string') return '';

	return string.charAt(0).toLocaleUpperCase() + string.slice(1);
}
